import { formatDateTime } from './format'

const KB_STATUS_TO_API = { draft: 1, published: 2, disabled: 3 }
const KB_STATUS_FROM_API = { 1: 'draft', 2: 'published', 3: 'disabled' }

const ROLE_TO_API = { '超级管理员': 1, '知识库创建者': 2, '被考核者': 3 }
const ROLE_FROM_API = { 1: '超级管理员', 2: '知识库创建者', 3: '被考核者' }

const ROLE_KEY_FROM_ID = { 1: 'admin', 2: 'creator', 3: 'examinee' }

export function roleKeyFromId(roleId) {
  return ROLE_KEY_FROM_ID[roleId] || 'creator'
}

export function roleToApi(role) {
  return ROLE_TO_API[role] || 2
}

export function adaptAdmin(item) {
  if (!item) return item
  return {
    id: item.id,
    acc: item.account,
    name: item.real_name || '',
    role: ROLE_FROM_API[item.role_id] || '知识库创建者',
    roleId: item.role_id,
    enabled: true,
    mobile: item.mobile || '',
    createdAt: formatDateTime(item.created_at),
    updatedAt: formatDateTime(item.updated_at)
  }
}

export function adaptKnowledge(item, withContent = false) {
  if (!item) return item
  const tags = typeof item.tags === 'string'
    ? item.tags.split(',').map(t => t.trim()).filter(Boolean)
    : (item.tags || [])
  const adapted = {
    id: item.id,
    kbId: item.kb_id,
    title: item.title || '',
    purpose: item.purpose || '',
    attachmentUrl: item.attachment_url || '',
    faqDocumentId: item.faq_document_id || '',
    faqDocumentStatus: item.faq_document_status,
    tags,
    status: KB_STATUS_FROM_API[item.status] || 'draft',
    creator: item.creator_account || '',
    createdAt: formatDateTime(item.created_at),
    updatedAt: formatDateTime(item.updated_at)
  }
  if (withContent) adapted.content = item.content || ''
  return adapted
}

export function knowledgeToApi(payload) {
  const body = {}
  if (payload.title != null) body.title = payload.title
  if (payload.purpose != null) body.purpose = payload.purpose
  if (payload.content != null) body.content = payload.content
  if (payload.attachmentUrl != null) body.attachment_url = payload.attachmentUrl
  if (payload.tags != null) {
    body.tags = Array.isArray(payload.tags) ? payload.tags.join(',') : payload.tags
  }
  if (payload.status != null) {
    body.status = KB_STATUS_TO_API[payload.status] || payload.status
  }
  return body
}

export function adaptPreset(item) {
  if (!item) return item
  return {
    id: item.id,
    q: item.content,
    on: item.status === 1,
    sortOrder: item.sort_order || 0,
    createdAt: formatDateTime(item.created_at),
    updatedAt: formatDateTime(item.updated_at)
  }
}

export function presetToApi(payload) {
  const body = {}
  if (payload.q != null) body.content = payload.q
  if (payload.on != null) body.status = payload.on ? 1 : 2
  if (payload.sortOrder != null) body.sort_order = payload.sortOrder
  return body
}

export function adaptFeedback(item) {
  if (!item) return item
  return {
    id: item.id,
    askRecordId: item.ask_record_id,
    conversationId: item.conversation_id,
    type: item.feedback_type === 1 ? 'like' : 'dislike',
    question: item.question || '',
    reason: item.reason || '',
    text: item.reason || '',
    resolved: item.handle_status === 2,
    note: item.handle_remark || '',
    time: formatDateTime(item.created_at),
    updatedAt: formatDateTime(item.updated_at)
  }
}

/** 格式化嵌套问答记录中的时间字段 */
export function formatRecordDates(record) {
  if (!record) return record
  return {
    ...record,
    created_at: formatDateTime(record.created_at),
    updated_at: formatDateTime(record.updated_at)
  }
}
